<template>
  <div id="messageCoupon">
    <div class="messtitle"><div>票券 </div> <span></span></div>
    <Coupon :style="{marginTop: '14px', width: '790px'}" v-if="coupon" :icon="'delete'" @selectThis="coupon=null"
      :image="coupon.image"
      :couponName="coupon.couponName"
      :productName="coupon.productName"
      :productID="coupon.productID"
      :startTime="coupon.startTime"
      :expireTime="coupon.expireTime"
      :duration="coupon.duration"
    />
    <div class="couponfill" :style="{marginTop: '14px'}" v-else>
      <div @click="selectone=true">
        <div class="svg"></div>
        <div class="but">選擇票券</div>
      </div>
    </div>
    <DialogDef @close="selectone=false" :show="selectone" label="優惠券" :height="'630px'">
      <div :style="{padding: '33px 30px 52px', overflowY: 'auto', overflowX: 'hidden',
        maxHeight: '560px', gap: '20px', display: 'flex', flexDirection: 'column',
        minHeight: '408px', minWidth: '760px'
      }">
        <RT :options="types" :defaultValue="couponType" @input="couponType=$event"/>
        <Coupon v-for="cp in coupons" :key="cp._id"
        :image="cp.image"
        :couponName="cp.couponName"
        :productName="cp.productName"
        :productID="cp.productID"
        :startTime="cp.startTime"
        :expireTime="cp.expireTime"
        :duration="cp.duration"
        @selectThis="coupon=cp;selectone=false"
        />
      </div>
    </DialogDef>
  </div>
</template>

<script>
import { getapi } from '../../../store/fetch'
import Coupon from '../../../components/couponBox.vue'
import DialogDef from '../../../components/dialognoPadding2.vue'
import { mapState } from 'vuex'
export default {
  props: ['defaultValue'],
  components: {
    Coupon,
    DialogDef
  },
  data () {
    return {
      coupon: null,
      selectone: false,
      coupons: [],
      couponType: '抵用券'
    }
  },
  computed: mapState({
    types: 'couponTypes'
  }),
  watch: {
    defaultValue: {
      handler () {
        this.coupon = this.defaultValue
      },
      deep: true,
      immediate: true
    },
    async couponType () {
      await this.getcoupons()
    },
    coupon: {
      handler () {
        if (this.coupon._id !== this.defaultValue?._id) {
          this.$emit('input', this.coupon)
        }
      },
      deep: true
    }
  },
  methods: {
    async getcoupons () {
      const coupons = await getapi(`couponTemplate/select?couponType=${this.couponType}`)
      this.coupons = coupons
    }
  },
  async mounted () {
    await this.getcoupons()
  }
}
</script>
<style lang="scss">
#messageCoupon {
  .headerBox {
    background-color: var(--color-pri);
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.couponfill {
  width: 790px;
  height: 200px;
  border: 1px solid #C4C4C4;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .svg {
    width: 35px;
    height: 28px;
    background-color: var(--color-pri);
    mask-image: url(/svg/icon/coupon.svg);
    margin: auto;
  }
  .but {
    margin-top: 13.33px;
    width: 100px;
    height: 35px;
    background-color: var(--color-pri);
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: .1em;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 18px;
  }
}
#messageCoupon {
  width: 790px;

}
.messtitle {
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  text-align: start;
}
</style>
